import React, { Component } from 'react';
import { withRouter } from 'react-router-dom';
import { Button, Dialog } from '@blueprintjs/core';
import SroFilterMenuDialog from './SroFilterMenuDialog';

class SroFilterMenu extends Component {
  constructor(...args) {
    super(...args);

    this.state = {
      autoFocus: true,
      canEscapeKeyClose: true,
      canOutsideClickClose: true,
      enforceFocus: true,
      hasBackdrop: true,
      isOpen: false,
      usePortal: true,
    };

    this.ToggleDialog = () => {
      this.setState({
        ...this.state,
        isOpen: !this.state.isOpen,
      });
    };

    this.CloseDialog = () => {
      this.setState({
        ...this.state,
        isOpen: false,
      });
    };
  }

  componentDidMount() {
    this.Unlisten = this.props.history.listen((location, action) => {
      this.CloseDialog();
    });
  }

  componentWillUnmount() {
    this.Unlisten();
  }

  render() {
    return (
      <div>
        <Button minimal icon="cog" onClick={this.ToggleDialog} />

        <Dialog
          className="WideDialog"
          isOpen={this.state.isOpen}
          onClose={this.ToggleDialog}
          {...this.state}
        >
          <SroFilterMenuDialog />{' '}
        </Dialog>
      </div>
    );
  }
}

export default withRouter(SroFilterMenu);
